export function getGlobalsFromSnippet(snippet: string) {
    const matches = snippet.match(/(\(window,\s*document,\s*'script',\s*')(\S+)('\))/g) || [];
    const globals = matches.map((match) => (match.split(",")[3] || "").slice(1, -2))
    return Array.from(new Set(globals));
}
